import { Flow } from '@/components/Flow';
import { Step } from '@/components/Step';

export const DocumentNotFoundFlow = () => {
  return (
    <Flow>
      <Flow.StepList>
        <Step name='document-not-found-capture' />
      </Flow.StepList>
    </Flow>
  );
};
